module.exports = __webpack_public_path__ + "static/share-a20a41418524cf5881cbb63776394307.svg";